import * as types from './types';
import TranslationsService from '../../services/TranslationsService';

export const fetchTranslationsList = () => async (dispatch, getStore) => {
    const { info, item } = await TranslationsService.getTranslations();

    if (!info.success) return;

    const translations = item.jsonData;
    const { translationMode } = getStore().settings;

    if (translationMode) {
        const translationKeys = {};

        Object.keys(translations).forEach(key => {
            translationKeys[key] = key;
        });

        dispatch(setTranslationsKeys(translationKeys));
    }

    dispatch(setTranslationsList(translations));
};

export const setTranslationsList = payload => ({
    type: types.TRANSLATIONS_LIST_CHANGED,
    payload,
});

export const setTranslationsKeys = payload => ({
    type: types.TRANSLATIONS_KEYS_CHANGED,
    payload,
});
